import { ComposeStateType, MessageEditor } from "./reducer.types";

export const SELF_BOOK_MESSAGE_BODY = "We'd like you to book an appointment";

export const MAX_MESSAGE_LENGTH = 612;
export const START_OF_WORK_DAY = 8;

export const EMPTY_STATE_CONTACT_DETAILS: ComposeStateType["contactDetails"] = {
    method: "None",
};

export const MESSAGE_EMPTY_STATE: MessageEditor = {
    messageBody: "",
    messageSignature: "",
    attachments: [],
    isPatientResponseEnabled: false,
    sendAt: null,
    selfBookLink: null,
    nhsAdviceLink: null,
    isScheduling: false,
    messageEditorErrors: undefined,
};
export const COMPOSE_INITIAL_STATE: ComposeStateType = {
    canUseQuestionnaires: true,
    conversationParticipant: "WithPatient",
    maxAttachmentCount: 1,
    originalGreeting: "",
    originalBody: "",
    originalSignature: "",
    template: { type: "NoTemplate" },
    messages: [MESSAGE_EMPTY_STATE],
    isSaveToRecordEnabled: true,
    isSelfbookConfigurationOpen: false,
    contactDetails: EMPTY_STATE_CONTACT_DETAILS,
    topLevelErrors: undefined,
};
